import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {Component} from 'react';

import AddFilter from './AddFilter';
import {updateField} from '../../actions/CreatingObjectPage';
import * as ObjectConsts from '../../constants/Property';

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

const defaultProps = {
    updateField: (objectId, updateFieldCommand) => {
    }
};

class Amenities extends Component {
    constructor(props) {
        super(props);

        this.state = {
            amenities: []
        }
    }

    componentWillReceiveProps(nextProps) {
        let amenities = [];

        nextProps.createdObject.amenities.forEach(item => {
            amenities.push(item);
        });
        this.setState({
            amenities: amenities
        })
    }

    updateField(values) {
        const updateFieldCommand = {
            name: ObjectConsts.FIELDS.AMENITIES,
            value: values
        };

        this.props.updateField(this.props.createdObject.id, updateFieldCommand);
    }

    handleChange(event) {
        let amenities = this.state.amenities;
        let index = amenities.indexOf(event.target.value);

        if (index > -1) {
            amenities.splice(index, 1);
        } else {
            amenities.push(event.target.value);
        }
        this.updateField(amenities.join(','));

        this.setState({
            amenities: amenities
        });
    }

    render() {
        const i18n = this.props.i18n;

        return (
            <div className={
                this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
            }>
                <div className="heading">
                    <h3>
                        {i18n['creatingObjectPage.facilities']}
                    </h3>
                </div>
                <p className="wall-text">{i18n['creatingObjectPage.facilities.heading']}</p>
                <div className="check-intro">
                    <div className="clearfix options check">
                        {this.props.amenities.map((item, index, array) => {
                                if (index <= array.length / 2) {
                                    return (
                                        <label key={item.value} className="checkbox">
                                            <input
                                                type="checkbox"
                                                value={item.value}
                                                onChange={::this.handleChange}
                                                name={item.value}
                                                checked={this.state.amenities.indexOf(item.value) !== -1}
                                            />
                                            <span>{item.title}</span>
                                        </label>
                                    )
                                } else {
                                    return null;
                                }
                            }
                        )}
                    </div>

                    <div className="clearfix options check">
                        {this.props.amenities.map((item, index, array) => {
                                if (index > array.length / 2) {
                                    return (
                                        <label key={item.value} className="checkbox">
                                            <input
                                                type="checkbox"
                                                value={item.value}
                                                onChange={::this.handleChange}
                                                name={item.value}
                                                checked={this.state.amenities.indexOf(item.value) !== -1}
                                            />
                                            <span>{item.title}</span>
                                        </label>
                                    )
                                } else {
                                    return null;
                                }
                            }
                        )}
                    </div>
                </div>

                {process.env.NODE_ENV === 'development' && <AddFilter/>}
            </div>
        )
    }
}

Amenities.propTypes = propTypes;
Amenities.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    amenities: state.configuration.object.amenities,
    createdObject: state.creatingObjectPage.createdObject
});

const mapDispatchToProps = {
    updateField
};

export default connect(mapStateToProps, mapDispatchToProps)(Amenities);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/Amenities.js